export default __webpack_public_path__ + "static/media/536.ad0be778.gif";